export default __webpack_public_path__ + "static/media/view.9e4199e1.svg";